import React, {useState, useRef} from "react";
import assets from "../assets/imgs";

function MainButton({text, onClick, onRed = true, btnWidth=152, btnHeight=48}){
    return(
      <div style={{...(onRed ? styles.redButton : styles.whiteButton), 
        height: `${btnHeight}px`, width: `${btnWidth}px`
      }} className="font-body2-semibold" onClick={onClick}>
        {text}
      </div>
    );
  }
  
  const styles ={
    searchInput:{
      padding: '12px', width: '270px' , height: "45px", borderRadius: "8px", gap: "10px",
      boxSizing: "border-box", border: "1px solid var(--grayscale-cool_40)", background: "var(--grayscale-cool_20)",
      display: "flex", justifyContent: "flex-start", alignItems: "center", cursor: "text"
    },
    redButton:{
      width: `150px`,
      height: `48px`,
      backgroundColor: "var(--primary-crimson_40)",
      color: "white",
      display:"flex",
      alignItems:"center",
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: "8px",
    },
    whiteButton:{
      width: "150px",
      height: "48px",
      backgroundColor: "white",
      border: "1px solid var(--primary-crimson_40)",
      color: "var(--primary-crimson_40)",
      display:"flex",
      alignItems:"center",
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: "8px",
    }
  }
  
  const Buttons ={
    MainButton
  }
  export default Buttons;